module.exports = __webpack_public_path__ + "static/media/turokafteri_full1.33a63a7a.jpg";